import { deleteWebApi, fetchWebApi, postWebApi, putWebApi } from '../../webapis/dashboard';
import endpoints from '../../Endpoints';

export const getDefaultYearUrl = () => {
    const { gsodBaseUrl, defaultBmYrPath } = endpoints;
    const url = `${gsodBaseUrl}${defaultBmYrPath}`;
    return fetchWebApi(url).request;
};

// export const getFilterDataUrl = year => {

//     const { gsodBaseUrl, filterDataPath } = endpoints;
//     const url = `${gsodBaseUrl}${filterDataPath}?year=${year}`;
//     return fetchWebApi(url).request;
// };

export const getFilterDataUrl = options => {
    const { year, role } = options;
    const { gsodBaseUrl, filterDataPath } = endpoints;
    const url = `${gsodBaseUrl}${filterDataPath}?year=${year}`;
    return fetchWebApi(url).request;
};

export const getFilterMappingUrl = year => {
    const { gsodBaseUrl, filterMappingPath } = endpoints;
    const url = `${gsodBaseUrl}${filterMappingPath}?year=${year}`;
    return fetchWebApi(url).request;
};

export const getBmFilterDataUrl = () => {
    const { gsodBaseUrl, bmFilterDataPath } = endpoints;
    const url = `${gsodBaseUrl}${bmFilterDataPath}`;
    return fetchWebApi(url).request;
};

export const getAnalyticsDataUrl = options => {
    const { gsodBaseUrl, analyticsDataPath } = endpoints;
    const url = `${gsodBaseUrl}${analyticsDataPath}?filters=${options}`;
    return fetchWebApi(url).request;
};

export const getAnalyticsRankingUrl = options => {
    const { gsodBaseUrl, analyticsRankingPath } = endpoints;
    const url = `${gsodBaseUrl}${analyticsRankingPath}?rank_type=overall&filters=${options}`;
    return fetchWebApi(url).request;
};

export const getDifferentialUrl = options => {
    const { filters = '', remove_threshold = '' } = options;
    const { gsodBaseUrl, analyticsRankingPath } = endpoints;
    const url = `${gsodBaseUrl}${analyticsRankingPath}?rank_type=differentiator&filters=${filters}&skip_threshold=${remove_threshold}`;
    return fetchWebApi(url).request;
};

export const getFlagpoleUrl = options => {
    const { gsodBaseUrl, analyticsScorecardPath } = endpoints;
    const url = `${gsodBaseUrl}${analyticsScorecardPath}?analysis_type=flagpole&filters=${options}`;
    return fetchWebApi(url).request;
};

export const getAnalyticsPerCategoryUrl = options => {
    const { gsodBaseUrl, analyticsPerCategoryPath } = endpoints;
    const { filters = '', filter_id = '' } = options;
    const url = `${gsodBaseUrl}${analyticsPerCategoryPath}?filters=${filters}&filter_id=${filter_id}`;
    return fetchWebApi(url).request;
};

export const getScorecardUrl = options => {
    const { gsodBaseUrl, analyticsScorecardPath } = endpoints;
    const { filters = '' } = options || {};
    const url = `${gsodBaseUrl}${analyticsScorecardPath}?analysis_type=scorecard&filters=${filters}`;
    return fetchWebApi(url).request;
};

export const getMedianUrl = options => {
    const { filters = '', remove_threshold = '' } = options;
    const { gsodBaseUrl, analyticsRankingPath } = endpoints;
    const url = `${gsodBaseUrl}${analyticsRankingPath}?rank_type=mediansplit&filters=${filters}&skip_threshold=${remove_threshold}`;
    return fetchWebApi(url).request;
};

export const getCustomBmSurveyListUrl = options => {
    const { gsodBaseUrl, customBmSurveyListPath } = endpoints;
    const url = `${gsodBaseUrl}${customBmSurveyListPath}?filters=${options}`;
    return fetchWebApi(url).request;
};

export const getCustomBmListUrl = options => {
    const { gsodBaseUrl, customBmListPath } = endpoints;
    const url = `${gsodBaseUrl}${customBmListPath}`;
    return postWebApi(url, options).request;
};

export const saveCustomBmDraft = options => {
    const { gsodBaseUrl, customBmPath } = endpoints;
    const url = `${gsodBaseUrl}${customBmPath}`;
    return postWebApi(url, options).request;
};

export const getCustomBmDetails = options => {
    const { gsodBaseUrl, customBmDetail } = endpoints;
    const path = customBmDetail.replace(/\/$/, '');
    const url = `${gsodBaseUrl}${path}/${options}`;
    return fetchWebApi(url).request;
};

export const deleteCustomBenchmark = id => {
    const { gsodBaseUrl, deleteCustomBm } = endpoints;
    const path = deleteCustomBm.replace(/\/$/, '');
    const url = `${gsodBaseUrl}${path}/${id}`;
    return deleteWebApi(url).request;
};

export const updateCustomBenchmark = options => {
    const { id, payload } = options;
    const { gsodBaseUrl, editCustomBm } = endpoints;
    const path = editCustomBm.replace(/\/$/, '');
    const url = `${gsodBaseUrl}${path}/${id}`;
    return putWebApi(url, payload).request;
};

export const checkNameExist = options => {
    const { gsodBaseUrl, checkCustomBmNameExist } = endpoints;
    const url = `${gsodBaseUrl}${checkCustomBmNameExist}`;
    return postWebApi(url, options).request;
};

export const sendCustomBmRequest = options => {
    const { id, payload } = options;
    const { gsodBaseUrl, sendCustomBmReq } = endpoints;
    const url = `${gsodBaseUrl}${sendCustomBmReq}${id}`;
    return putWebApi(url, payload).request;
};

export const getSurveyList = options => {
    const { q = '', year = '' } = options || {};
    const { apiBasePath, searchOhiIds } = endpoints;
    const url = `${apiBasePath}${searchOhiIds}?year=${year}&q=${q}`;
    return fetchWebApi(url).request;
};

export const approvalRequest = options => {
    const { gsodBaseUrl, requestedBenchmark } = endpoints;
    const { status, filters, page, limit } = options || {};
    const url = `${gsodBaseUrl}${requestedBenchmark}?status=${status}&filters=${filters}&limit=${limit}&page=${page}`;
    return postWebApi(url, {}).request;
};

export const approveRequest = id => {
    const { gsodBaseUrl, approveReq } = endpoints;
    const url = `${gsodBaseUrl}${approveReq}${id}`;
    return putWebApi(url, {}).request;
};

export const rejectRequest = id => {
    const { gsodBaseUrl, rejectReq } = endpoints;
    const url = `${gsodBaseUrl}${rejectReq}${id}`;
    return putWebApi(url, {}).request;
};

export const duplicateCustomBm = id => {
    const { gsodBaseUrl, duplicateBm } = endpoints;
    const url = `${gsodBaseUrl}${duplicateBm}${id}`;
    return putWebApi(url, {}).request;
};

export const checkValidation = options => {
    const { gsodBaseUrl, preApproveValidation } = endpoints;
    const url = `${gsodBaseUrl}${preApproveValidation}${options}`;
    return fetchWebApi(url).request;
};

export const getRealtimeYearUrl = () => {
    const { gsodBaseUrl, realTimeYearPath } = endpoints;
    const url = `${gsodBaseUrl}${realTimeYearPath}`;
    return fetchWebApi(url).request;
};

export const getRealtimeAnalyticsUrl = options => {
    const { gsodBaseUrl, realTimeAnalyticsPath } = endpoints;
    const url = `${gsodBaseUrl}${realTimeAnalyticsPath}?filters=${options}`;
    return fetchWebApi(url).request;
};

export const getRealtimeSurveyListUrl = options => {
    const { gsodBaseUrl, realTimeAnalyticsList } = endpoints;
    const url = `${gsodBaseUrl}${realTimeAnalyticsList}?filters=${options}`;
    return fetchWebApi(url).request;
};

export const realtimeApproveRequestUrl = options => {
    const { id, year, is_benchmark_approved, is_research_approved } = options;
    const { gsodBaseUrl, realTimeApprovePath } = endpoints;
    const url = `${gsodBaseUrl}${realTimeApprovePath}?year=${year}&is_benchmark_approved=${is_benchmark_approved}&is_research_approved=${is_research_approved}`;
    return putWebApi(url, id).request;
};

export const realtimeRejectUrl = options => {
    const { id, year } = options;
    const { gsodBaseUrl, realTimeRejectPath } = endpoints;
    const url = `${gsodBaseUrl}${realTimeRejectPath}?year=${year}`;
    return putWebApi(url, id).request;
};

export const getRealtimeFiltersUrl = year => {
    const { gsodBaseUrl, reatimeFiltersPath } = endpoints;
    const url = `${gsodBaseUrl}${reatimeFiltersPath}?year=${year}`;
    return fetchWebApi(url).request;
};

export const putRefreshMetaUrl = options => {
    const { id, year } = options;
    const { gsodBaseUrl, refreshRealTimeMeta } = endpoints;
    const url = `${gsodBaseUrl}${refreshRealTimeMeta}?year=${year}`;
    return putWebApi(url, id).request;
};

export const realtimeDownloadUrl = options => {
    const {
        filters = '',
        include_meta = false,
        include_ohi_score = false,
        include_ex_score = false,
        include_qbyq_score = false,
    } = options;
    const { gsodBaseUrl, realTimeDownloadPath } = endpoints;
    const params = new URLSearchParams({
        filters,
        include_meta,
        include_ohi_score,
        include_ex_score,
        include_qbyq_score,
    });
    const url = `${gsodBaseUrl}${realTimeDownloadPath}?${params.toString()}`;
    return fetch(url, {
        method: 'GET',
        headers: {
            Authorization: `${localStorage.getItem('accessToken')}`,
        },
    });
};
